import React, {useState} from "react";
import stringUtils from "../../../../utils/string_utils";
import {v4 as uuidv4} from "uuid";
import Skeleton from "@mui/material/Skeleton";
import {
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table,
    TableBody,
} from "@mui/material";
import {
    styleContainerList,
    styleListingOutLine,
    styleTableCellHeader,
} from "../../../../utils/common_style_for_list";
import {assignDriverApiCall, commonTaskApiCall} from "../../../controllers/unassigned_controllers";
import {useEffect} from "react";
import {CommonTaskModel} from "../../../models/unassigned_task_model";
import CommonColorUtils from "../../../../utils/common_colors";
import {FullButton} from "../../../../components/button/common_button";
import DriverDropdown from "../driver_dropdown";
import CommonTextWithRoundedShape from "../../../../components/CommonTextWithRoundedShape";
import {
    convertTo12Hour,
    localDateFormatWithMonthName,
    localTimeFormat
} from "../../../../utils/date_time_convert_utils";
import {showSuccessToast} from "../../../../components/toast/success_toast";
import {showErrorToast} from "../../../../components/toast/error_toast";
import No_Record_Found_Page from "../no_record_found_page";
import PickupOrderDetailsScreen from "../order_details_pages/pickup_order_details_screen";
import RtoOrderDetailsScreen from "../order_details_pages/rto_order_details_screen";
import ReturnOrderDetailsScreen from "../order_details_pages/return_order_deatails_screen";

const textColorMap = {
  "#FFDBDB": CommonColorUtils.primaryErrorDarkColor,
  "#FFF5E5": CommonColorUtils.kSecondaryAlert500,
  "#DFECE9": CommonColorUtils.kPrimeGreenDarker,
};

const UnassignedTaskPage = ({selectedHubId, driverList, driverListMap,countTaskApiCalling,selectedTypes,selectedFilter,selectedIds, selectedVendors, setIsLoading, setCommonCount=()=>{}}) => {
    let firstRender = true;
    const [isBusy, setIsBusy] = useState(false);
    const [isBusyForDriver, setIsBusyForDriver] = useState(false);
    const [unassignedTaskList, setUnassignedTaskList] = useState([]);
    const [assignButtonActive, setAssignButtonActive] = useState({});
    const [selectedDriverUid, setSelectedDriverUid] = useState({});
    const [pickUpDialogOpen, setPickUpDialogOpen] = useState(false);
    const [selectedTaskId, setSelectedTaskId] = useState('');
    const [rtoDialogOpen, setRtoDialogOpen] = useState(false);
    const [returnDialogOpen, setReturnDialogOpen] = useState(false);
    const columns = [
        {id: "clientLocation", label: stringUtils.pickupLocation, width: "150px"},
        {id: "address", label: stringUtils.pickupAddress, width: "150px"},
        {id: "vendorName", label: stringUtils.vendorName, width: "150px"},
        // {id: "destinationHubLocationName", label: stringUtils.destinationHub, width: "150px"},
        {id: "visitTime", label: stringUtils.visitTime,width: "80px" },
        {id: "taskId", label: stringUtils.taskId, width: "100px" },
        {id: "tasksType", label: stringUtils.tasks, width: "100px" },
        {id: "createdDate", label: stringUtils.createdOn, width: "120px" },
        {id:"taskAge", label: stringUtils.taskAge.toUpperCase(), width: "80px"},
        {id: "driver", label: stringUtils.driver, width: "150px" },
        {id: "action", label: stringUtils.action.toUpperCase(), width: "80px" },
    ];
    const unassignedTaskListApiCalling = async () => {
        try {
            setIsBusy(true);
            const response = await commonTaskApiCall('unassigned',selectedTypes,selectedFilter,selectedIds,selectedVendors);
            if (response) {
                const unassignedTaskModel = CommonTaskModel.fromJson(response);
                setCommonCount((prevCount) => ({
                    ...prevCount,
                    unAssignedCount: response?.task_count||0,
                }));
                setUnassignedTaskList(unassignedTaskModel.taskLocation);
            }
        } catch (e) {
            setUnassignedTaskList([]);
            console.error(e);
        } finally {
            setIsBusy(false);
        }
    };
    const handleOnChangeDriver = (rowIndex, event) => {
        const newUid = event.target.value;
        setSelectedDriverUid((prevUids) => ({
            ...prevUids,
            [rowIndex]: newUid,
        }));
        setAssignButtonActive((prevActiveBtn) => ({
            ...prevActiveBtn,
            [rowIndex]: true,
        }));
    };
    const handleAssignButtonOnpress = async (driverUid, taskId, rowIndex) => {
      if (isBusyForDriver) return;
      if (!assignButtonActive[rowIndex]) {
        showErrorToast("Select Driver");
        return;
      }
      try {
        setIsBusyForDriver(true);
        const driver = driverListMap.get(driverUid);
        if (!driver) {
          showErrorToast("Driver not found");
          return;
        }
        const response = await assignDriverApiCall(driver?.email, taskId,driver?.id,driver?.name);
        if (response) {
          unassignedTaskListApiCalling();
          countTaskApiCalling();
          setAssignButtonActive({});
          setSelectedDriverUid({});
          showSuccessToast(response.message);
        }
      } catch (e) {
        showErrorToast("Something went wrong");
      } finally {
        setIsBusyForDriver(false);
      }
    };
    const handlePickupDialogOpen = () => {
        setPickUpDialogOpen(true);
    }
    const handlePickupDialogClose = () => {
        setPickUpDialogOpen(false);
    }

    const handleRtoDialogOpen = () => {
        setRtoDialogOpen(true);
    }
    const handleRtoDialogClose = () => {
        setRtoDialogOpen(false);
    }

    const handleReturnDialogOpen = () => {
        setReturnDialogOpen(true);
    }
    const handleReturnDialogClose = () => {
        setReturnDialogOpen(false);
    }

    const openOrderDetailsPage = (orderType, taskId) => {
        setSelectedTaskId(taskId);
        if (orderType.toLowerCase() === 'pick up') {
            handlePickupDialogOpen();
        }
        else if(orderType.toLowerCase() === 'rto') {
            handleRtoDialogOpen()
        }
        else if(orderType.toLowerCase() === 'return') {
            handleReturnDialogOpen()
        }
    }
    useEffect(() => {
        if (firstRender) {
            unassignedTaskListApiCalling();
            firstRender = false;
        }
    }, [selectedHubId,selectedTypes,selectedIds,selectedVendors ]);
    useEffect(() => {
    setIsLoading(isBusy);
}, [isBusy]);

    const spanStyle = {
        display: "flex",
        alignItems: "left",
        flexDirection: "column",
        whiteSpace: "normal",
        wordWrap: "break-word",
    }
    return (
        <>
            <div style={styleListingOutLine}>
                {!isBusy && unassignedTaskList.length === 0 ? (
                    <No_Record_Found_Page noRecordTitle={stringUtils.noUnassignedTasks}
                                          noRecordDescription={stringUtils.driverAssignmentIsNotYetDone}/>
                ) : (
                    <>
                        {isBusy ? (<>
                            {Array.from({length: 20}).map((_, index) => (
                                <div key={index}>
                                    <Skeleton
                                        variant="rectangular"
                                        width={'100%'}
                                        height={80}
                                        style={{
                                            marginBottom: '8px', flex: 1,
                                            overflowX: 'auto',
                                        }} // Optional styling for spacing
                                    />
                                </div>
                            ))}
                        </>) : (

                            <div style={{overflowY: 'auto',...(!localStorage.getItem('isFromHostApplication') ?{height: 'calc(75vh)'}:{height: 'calc(70vh)'})}}>
                                <TableContainer style={{ ...styleContainerList, maxHeight: "100%" }}>
                                    <Table stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                {columns.map((colum) => (
                                                    <TableCell key={colum?.id || colum?.label} align={"left"} style={{...styleTableCellHeader,width: colum.width} }>
                                                        {colum.label}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                unassignedTaskList.map((row, rowIndex) => (

                                                        <TableRow
                                                            key={rowIndex}
                                                            style={{
                                                                backgroundColor: CommonColorUtils.kPrimaryPureWhite,
                                                            }}
                                                        >
                                                            {columns.map((column, columnIndex) => (
                                                                <TableCell
                                                                    key={`${rowIndex}-${columnIndex}`}
                                                                    align={"left"}
                                                                    style={{
                                                                        padding: "0px",
                                                                        paddingLeft: column.id === 'taskType' ? '0px' : "10px",
                                                                        paddingRight: "20px",
                                                                        height: "54px",
                                                                        borderBottom: `1px solid ${CommonColorUtils.primaryGrey300}`,
                                                                        width: `${100 / columns.length}%`,
                                                                        fontFamily: "Inter, Arial, sans-serif",
                                                                        color: CommonColorUtils.primaryGrey700,
                                                                        fontWeight:
                                                                            column.id === "clientLocation" || column.id === "status" ? 600 : 400,
                                                                        fontSize: "14px",
                                                                    }}
                                                                >
                                                                    {(() => {
                                                                        if (column.id === "driver") {
                                                                            return (
                                                                                <>
                                                                                    <DriverDropdown
                                                                                        options={driverList}
                                                                                        selectedValue={
                                                                                            selectedDriverUid[rowIndex] || ""
                                                                                        }
                                                                                        onChange={(event) =>
                                                                                            handleOnChangeDriver(rowIndex, event)
                                                                                        }
                                                                                    />
                                                                                </>
                                                                            );
                                                                        } else if (column.id === "action") {
                                                                            return (
                                                                                <>
                                                                                    <FullButton
                                                                                    
                                                                                        buttonText={(isBusyForDriver&&assignButtonActive[rowIndex])?stringUtils.assigning:stringUtils.assign}
                                                                                        activeColor={
                                                                                            CommonColorUtils.primaryMainBlue
                                                                                        }
                                                                                        inactiveColor={
                                                                                            CommonColorUtils.primaryMainBlueDisabledColor
                                                                                        }
                                                                                        buttonTextColor={
                                                                                            CommonColorUtils.primaryKWhite
                                                                                        }
                                                                                        active={
                                                                                            assignButtonActive[rowIndex] || false
                                                                                        }
                                                                                        isDisable={isBusyForDriver}
                                                                                        height={"40px"}
                                                                                        width={"100px"}
                                                                                        handleOnPress={isBusyForDriver?()=>{}:() => handleAssignButtonOnpress(selectedDriverUid[rowIndex], row['taskId'], rowIndex)}
                                                                                    />
                                                                                </>
                                                                            );
                                                                        } else if (column.id === "tasksType") {
                                                                            let colorText = CommonColorUtils.kPrimeGreenDarker;
                                                                            let colorBG = CommonColorUtils.kPrimeGreenDarkShade;
                                                                            if (row[column.id].type.toLowerCase() === 'return') {
                                                                                colorBG = CommonColorUtils.kPrimePurpleLightShade;
                                                                                colorText = CommonColorUtils.kPrimePurpleDarkShade;
                                                                            }
                                                                            if (row[column.id].type.toLowerCase() === 'rto') {
                                                                                colorBG = CommonColorUtils.krtoBackgroundColor;
                                                                                colorText = CommonColorUtils.krtoTextColor;
                                                                            }

                                                                            return (
                                                                                <>
                                                                                    <div
                                                                                        onClick={() => openOrderDetailsPage(row[column.id].type, row['taskId'])}
                                                                                        style={{
                                                                                            cursor: 'pointer'
                                                                                        }}>
                                                                                        <CommonTextWithRoundedShape
                                                                                            text={`${row[column.id].type} (${row[column.id].count})`}
                                                                                            backgroundColor={
                                                                                                colorBG
                                                                                            }
                                                                                            color={
                                                                                                colorText
                                                                                            }
                                                                                            verticalPadding={0}
                                                                                            leftMarging={0}

                                                                                        />
                                                                                    </div>
                                                                                </>
                                                                            );
                                                                        } else if (column.id === 'visitTime') {
                                                                            return <span style={{ ...spanStyle,width:column.width,}}>
                                                                           {convertTo12Hour(row[column.id])}
                                                                        </span>;
                                                                        } else if (column.id === 'createdDate') {
                                                                            return `${localDateFormatWithMonthName(row[column.id])} at ${localTimeFormat(row[column.id])}`;
                                                                        } else if (column.id === 'taskAge') {
                                                                            return <CommonTextWithRoundedShape
                                                                                            text={`${row[column.id]?.days || 0} ${stringUtils.days}`}
                                                                                            backgroundColor={row[column.id]?.color_code}
                                                                                            color={textColorMap[row[column.id]?.color_code] ?? CommonColorUtils.primaryGrey700}
                                                                                            fontWeight={600}
                                                                                            verticalPadding={0}
                                                                                            leftMarging={0}
                                                                                        />                                                          
                                                                        } else {
                                                                            return <div style={{
                                                                            ...spanStyle,width:column.width,
                                                                        }}>
                                                                            {row[column.id]}
                                                                        </div>;
                                                                        }
                                                                    })()}
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>

                                                ))
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        )}
                    </>
                )}
            </div>
            <PickupOrderDetailsScreen open={pickUpDialogOpen} onClose={handlePickupDialogClose}
                                      navigatedFrom={stringUtils.unassignedTasks} taskId={selectedTaskId}
                                      driverName={''}/>
            <RtoOrderDetailsScreen open={rtoDialogOpen} onClose={handleRtoDialogClose}
                                   navigatedFrom={stringUtils.unassignedTasks} taskId={selectedTaskId} driverName={''}/>
            <ReturnOrderDetailsScreen open={returnDialogOpen} onClose={handleReturnDialogClose}
                                   navigatedFrom={stringUtils.unassignedTasks} taskId={selectedTaskId} driverName={''}/>
        </>
    );
};
export default UnassignedTaskPage;
